import {
  Component,
  computed,
  ContentChildren,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  QueryList,
  input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PayeeRadioButtonComponent } from '../payee-radio-button/payee-radio-button.component';
import { PayeeRadioChange } from '../payee-radio-change';

@Component({
  selector: 'payee-radio-group',
  templateUrl: './payee-radio-group.component.html',
  styleUrls: ['./payee-radio-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayeeRadioGroupComponent),
      multi: true,
    },
  ],
  imports: [PayeeRadioButtonComponent],
  host: {
    '[class.vertical]': 'isVertical()',
  },
})
export class PayeeRadioGroupComponent implements ControlValueAccessor {
  disabled: boolean = false;

  @Input() value: unknown = null;
  @Output() valueChange = new EventEmitter<unknown>();

  readonly vertical = input<unknown>();
  readonly isVertical = computed(() => this.vertical() !== undefined);

  @Input() options: unknown[] = [];

  @Input() labelPosition: 'before' | 'after' = 'after';
  @Output() change = new EventEmitter<PayeeRadioChange>();

  @ContentChildren(PayeeRadioButtonComponent)
  radioButtons!: QueryList<PayeeRadioButtonComponent>;

  @Input() displayWith = (v: any): string => String(v);

  onChange = (_obj: unknown) => {};
  onTouched = () => {};

  registerOnChange(fn: typeof this.onChange): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: typeof this.onTouched): void {
    this.onTouched = fn;
  }

  writeValue(obj: unknown): void {
    this.value = obj;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectOption(obj: unknown): void {
    this.value = obj;
    this.valueChange.emit(obj);
    this.onChange(obj);
  }
}
